/**
 * LanguageSwitcher Component
 * 
 * Allows users to toggle between English and Vietnamese languages
 */

import React, { useState } from 'react';
import {
  IconButton,
  Menu,
  MenuItem,
  ListItemIcon,
  ListItemText,
  Tooltip,
} from '@mui/material';
import { Language as LanguageIcon } from '@mui/icons-material';
import { useTranslation } from 'react-i18next';

function LanguageSwitcher() {
  const { i18n, t } = useTranslation();
  const [anchorEl, setAnchorEl] = useState(null);
  const [currentLanguage, setCurrentLanguage] = useState(i18n.language || 'en');
  
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  
  const handleClose = () => {
    setAnchorEl(null);
  };
  
  const handleLanguageChange = (lang) => {
    i18n.changeLanguage(lang);
    setCurrentLanguage(lang);
    handleClose();
  };
  
  return (
    <>
      <Tooltip title={t('common.changeLanguage', 'Change Language')}>
        <IconButton
          onClick={handleClick}
          color="inherit"
          size="medium"
          className="header-action-btn"
        >
          <LanguageIcon fontSize="small" />
        </IconButton>
      </Tooltip>
      
      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        PaperProps={{
          sx: {
            mt: 1.5,
            minWidth: 180,
            boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
            borderRadius: 2,
            zIndex: 1300,
          },
        }}
      >
        <MenuItem
          onClick={() => handleLanguageChange('en')}
          selected={currentLanguage === 'en'}
          sx={{
            py: 1.5,
            px: 2,
            '&.Mui-selected': {
              backgroundColor: 'rgba(102, 126, 234, 0.1)',
              '&:hover': {
                backgroundColor: 'rgba(102, 126, 234, 0.15)',
              },
            },
          }}
        >
          <ListItemIcon sx={{ minWidth: 36 }}>
            <span style={{ fontSize: '1.5rem' }}>🇬🇧</span>
          </ListItemIcon>
          <ListItemText 
            primary="English" 
            primaryTypographyProps={{
              fontWeight: currentLanguage === 'en' ? 600 : 400,
            }}
          />
        </MenuItem>
        
        <MenuItem
          onClick={() => handleLanguageChange('vi')}
          selected={currentLanguage === 'vi'}
          sx={{
            py: 1.5,
            px: 2,
            '&.Mui-selected': {
              backgroundColor: 'rgba(102, 126, 234, 0.1)',
              '&:hover': {
                backgroundColor: 'rgba(102, 126, 234, 0.15)',
              },
            },
          }}
        >
          <ListItemIcon sx={{ minWidth: 36 }}>
            <span style={{ fontSize: '1.5rem' }}>🇻🇳</span>
          </ListItemIcon>
          <ListItemText 
            primary="Tiếng Việt"
            primaryTypographyProps={{
              fontWeight: currentLanguage === 'vi' ? 600 : 400,
            }}
          />
        </MenuItem>
      </Menu>
    </>
  );
}

export default LanguageSwitcher;
